module.exports = __webpack_public_path__ + "img/3.47303af9.jpg";